import { ApolloError, useQuery } from '@apollo/client'
import { DocumentNode } from 'graphql'
import { useEffect, useState } from 'react'
import { graphQLServerDataInterface, graphQLTableDataInterface, keyValue, QueryKeyTypes } from '../lib/types'
import {
  GET_ELEMENTS,
  GET_ELEMENT_TYPES,
  GET_PRODUCTS,
  GET_ELEMENT_MATERIALS,
  GET_ELEMENT_MATERIAL_CONF,
  GET_ELEMENT_ORIENTATIONS,
  GET_ELEMENT_NOTES,
  GET_PRODUCT_INSTALLATION_TYPES,
  GET_PRODUCT_TYPES,
  GET_PRODUCT_CATEGORIES,
  GET_PRODUCT_MANUFACTURERS,
  GET_PRODUCT_INSTRUCTION_LIST,
  GET_PRODUCT_MATCHING_LIST,
  GET_PRODUCT_INSTRUCTIONS,
  GET_PRODUCT_NOTES,
  GET_REPORT_TYPES,
  GET_REPORT_PUBLISHINGS,
  GET_REPORT_FACILITIES,
  GET_REPORT_STATUSES,
  GET_REPORT_STANDARD_LIST,
  GET_REPORTS,
  GET_REPORT_STANDARDS,
  GET_REPORT_NOTES,
  GET_SERVICE_TYPES,
  GET_SERVICE_CATEGORIES,
  GET_SERVICE_SUB_CATEGORIES,
  GET_SERVICE_MATERIALS,
  GET_SERVICE_MANUFACTURERS,
  GET_SERVICE_BRANDS,
  GET_SERVICE_STANDARDS,
  GET_SERVICE_STANDARD_MATCH,
  GET_SERVICE_ADD_TYPES,
  GET_SERVICE_ADD_MANUFACTURERS,
  GET_SERVICE_ADD_BRANDS,
  GET_SERVICE_ADD_GROUPS,
  GET_SERVICE_ADDS,
  GET_SERVICES,
  GET_SERVICE_NOTES,
  GET_FITTING_TYPES,
  GET_FIXING_CATEGORIES,
  GET_SEALING_METHODS,
  GET_SERVICE_CONFIGURATIONS,
  GET_APPLICATIONS,
  GET_INDUSTRY_CATEGORIES,
  GET_SYSTEM_NOTES,
  GET_SYSTEM_DOCS,
  GET_ALL_TYPES,
  GET_DOCUMENT_TYPES,
  GET_INQUIRIES,
  GET_UNITS,
  GET_DOCUMENT_VERSIONS,
  GET_DIMENSION_TYPES,
  GET_FRL_STANDARDS,
  GET_FAQS,
  GET_SYSTEM,
  GET_COMPONENT_PRODUCTS,
  GET_PRODUCT_SUB_CATEGORIES,
  GET_HOMEPAGE_TILES,
  GET_FIXING_TESTED,
  GET_FMP_PROJECTS,
  GET_SNAP_USERS,
  GET_PRODUCT_ACCESSORY_MATCH,
  GET_PRODUCT_BRANDS,
  GET_PRODUCT_INDUSTRIES,
  GET_SERVICE_INDUSTRIES,
  GET_ELEMENT_MOD_TYPES,
  GET_ELEMENT_MODS,
  GET_FIXING_GROUPS,
  GET_FIXING_MATCHLIST,
  GET_SYSTEM_NOTE_TYPES,
  GET_SYSTEM_NOTES_MATCHLIST,
  GET_QUALITY_CERTIFICATES
} from '../queries/queries'

const returnQuery = (key: string): DocumentNode => {
  switch (key) {
    case 'Document Types':
      return GET_DOCUMENT_TYPES
    case 'Email Inquiries':
      return GET_INQUIRIES
    case 'Home Page Tiles':
      return GET_HOMEPAGE_TILES
    case 'Quality Certificates':
      return GET_QUALITY_CERTIFICATES
    case 'SNAP Users':
      return GET_SNAP_USERS
    case 'FMP Projects':
      return GET_FMP_PROJECTS
    case 'Elements':
      return GET_ELEMENTS
    case 'Element Types':
      return GET_ELEMENT_TYPES
    case 'Products':
      return GET_PRODUCTS
    case 'Element Materials':
      return GET_ELEMENT_MATERIALS
    case 'Element Material Conf':
      return GET_ELEMENT_MATERIAL_CONF
    case 'Element Orientations':
      return GET_ELEMENT_ORIENTATIONS
    case 'Element Mod Types':
      return GET_ELEMENT_MOD_TYPES
    case 'Element Mods':
      return GET_ELEMENT_MODS
    case 'Element Notes':
      return GET_ELEMENT_NOTES
    case 'Product Installation Types':
      return GET_PRODUCT_INSTALLATION_TYPES
    case 'Product Types':
      return GET_PRODUCT_TYPES
    case 'Product Categories':
      return GET_PRODUCT_CATEGORIES
    case 'Product Sub Categories':
      return GET_PRODUCT_SUB_CATEGORIES
    case 'Product Manufacturers':
      return GET_PRODUCT_MANUFACTURERS
    case 'Product Brands':
      return GET_PRODUCT_BRANDS
    case 'Product Industries':
      return GET_PRODUCT_INDUSTRIES
    case 'Product Installation Instruction':
      return GET_PRODUCT_INSTRUCTION_LIST
    case 'Product Matching List':
      return GET_PRODUCT_MATCHING_LIST
    case 'Product Accessory Match':
      return GET_PRODUCT_ACCESSORY_MATCH
    case 'Product Instructions':
      return GET_PRODUCT_INSTRUCTIONS
    case 'Product Notes':
      return GET_PRODUCT_NOTES
    case 'Report Types':
      return GET_REPORT_TYPES
    case 'Report Publishing':
      return GET_REPORT_PUBLISHINGS
    case 'Report Facilities':
      return GET_REPORT_FACILITIES
    case 'Report Status':
      return GET_REPORT_STATUSES
    case 'Reporting Standards':
      return GET_REPORT_STANDARD_LIST
    case 'Reports':
      return GET_REPORTS
    case 'Report Standards':
      return GET_REPORT_STANDARDS
    case 'Report Notes':
      return GET_REPORT_NOTES
    case 'Service Types':
      return GET_SERVICE_TYPES
    case 'Service Categories':
      return GET_SERVICE_CATEGORIES
    case 'Service Sub Categories':
      return GET_SERVICE_SUB_CATEGORIES
    case 'Service Materials':
      return GET_SERVICE_MATERIALS
    case 'Service Manufacturers':
      return GET_SERVICE_MANUFACTURERS
    case 'Service Brands':
      return GET_SERVICE_BRANDS
    case 'Service Industries':
      return GET_SERVICE_INDUSTRIES
    case 'Service Standards':
      return GET_SERVICE_STANDARDS
    case 'Service Standard Match':
      return GET_SERVICE_STANDARD_MATCH
    case 'Service Add Types':
      return GET_SERVICE_ADD_TYPES
    case 'Service Add Manufacturers':
      return GET_SERVICE_ADD_MANUFACTURERS
    case 'Service Add Brands':
      return GET_SERVICE_ADD_BRANDS
    case 'Service Add Groups':
      return GET_SERVICE_ADD_GROUPS
    case 'Service Adds':
      return GET_SERVICE_ADDS
    case 'Services':
      return GET_SERVICES
    case 'Service Notes':
      return GET_SERVICE_NOTES
    case 'Fitting Types':
      return GET_FITTING_TYPES
    case 'Fixing Categories':
      return GET_FIXING_CATEGORIES
    case 'Fixing Tested':
      return GET_FIXING_TESTED
    case 'Fixing Groups':
      return GET_FIXING_GROUPS
    case 'Fixing Match List':
      return GET_FIXING_MATCHLIST
    case 'Sealing Methods':
      return GET_SEALING_METHODS
    case 'Service Configurations':
      return GET_SERVICE_CONFIGURATIONS
    case 'Applications':
      return GET_APPLICATIONS
    case 'Industry Categories':
      return GET_INDUSTRY_CATEGORIES
    case 'System Note Types':
      return GET_SYSTEM_NOTE_TYPES
    case 'System Notes':
      return GET_SYSTEM_NOTES
    case 'System Notes Match':
      return GET_SYSTEM_NOTES_MATCHLIST
    case 'System Docs':
      return GET_SYSTEM_DOCS
    case 'Units':
      return GET_UNITS
    case 'Document Versions':
      return GET_DOCUMENT_VERSIONS
    case 'Dimension Types':
      return GET_DIMENSION_TYPES
    case 'FRL Standards':
      return GET_FRL_STANDARDS
    case 'FAQs':
      return GET_FAQS
    case 'AllDataTypes':
      return GET_ALL_TYPES
    case 'Systems':
      return GET_SYSTEM
    case 'Component Products':
      return GET_COMPONENT_PRODUCTS
    default:
      return GET_ELEMENTS
  }
}
export const useLoadQuery = ({ query, variables }: { query: QueryKeyTypes; variables?: keyValue }): graphQLTableDataInterface => {
  const [data, setData] = useState<graphQLTableDataInterface>({
    loading: true,
    status: 'error'
  })
  const {
    data: grahQLData,
    error
  }: {
    data: graphQLServerDataInterface | undefined
    loading: boolean
    error?: ApolloError | undefined
  } = useQuery(returnQuery(query))
  const reducer = (graphQlData: graphQLServerDataInterface): keyValue[] => {
    const keys = Object.keys(graphQlData)
    return graphQlData[keys[0]]
  }
  useEffect(() => {
    if (grahQLData) {
      setData({
        loading: false,
        data: reducer(grahQLData) ?? undefined,
        status: !error ? 'success' : 'error',
        error
      })
    }
  }, [error, grahQLData])
  useEffect(() => {
    if (error) {
      setData({
        loading: false,
        data: undefined,
        status: 'error',
        error
      })
    }
  }, [error])

  return data
}
